import { useEffect, useRef } from "react";

// Pile d'intercepteurs du bouton retour.
//
// Le bouton retour d'Android ne connait que la pile d'ECRANS de App.jsx. Or
// plusieurs ecrans gerent leur propre navigation interne — les onglets de
// l'accueil, les etapes de publication, le carnet (liste / fiche / formulaire).
// Pour eux, un retour doit reculer D'UN CRAN A L'INTERIEUR de l'ecran, pas le
// quitter. Sans ca, l'utilisateur perd toute sa saisie, ou sort de l'app.
//
// Un ecran s'enregistre ici ; le retour lui est propose EN PREMIER, du plus
// recemment monte au plus ancien. Il rend true s'il l'a pris en charge, et
// App.jsx ne depile alors pas sa propre pile.

const handlers = [];

export function pushBackHandler(fn) {
  handlers.push(fn);
  return () => {
    const i = handlers.indexOf(fn);
    if (i >= 0) handlers.splice(i, 1);
  };
}

// Rend true si un ecran a consomme le retour.
export function runBackHandlers() {
  for (let i = handlers.length - 1; i >= 0; i--) {
    try {
      if (handlers[i]() === true) return true;
    } catch (e) {
      // Un intercepteur qui casse ne doit jamais bloquer le bouton retour.
      console.error("[back] intercepteur en erreur:", e);
    }
  }
  return false;
}

// La fonction passee change a chaque rendu : on la garde dans une ref pour ne
// pas se desabonner/reabonner en boucle, et on ne s'enregistre qu'une fois.
export function useBackHandler(fn, active = true) {
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!active) return undefined;
    return pushBackHandler(() => ref.current());
  }, [active]);
}
